<template>
    <div>
        <div class="code-warp" v-if="phoneUpload">
            <img class="code" :src="'data:image/gif;base64,' + codeImg" alt="">
            <div>微信扫一扫，手机上传，上传完毕后点击</div>
            <div class="mt20">
                <el-button type="primary"  @click="uploadCompany">已完成上传</el-button>
            </div>
        </div>
        <div class="uploadDialog-warp" v-else>
            <div class="btn" @click="localUpload">电脑本地上传</div>
            <div class="btn" @click="handlePhoneUpload">手机上传</div>
        </div>


    </div>
</template>
  
<script>
import { getAppUploadQr } from "@/api/history"; // 病历请求
export default {
    // 定义引入的组件
    components: {},
    props: {
        orderId: {
            type: String | Number,
            default: ''
        },
        // 来源 1门诊 2 补录处方
        source:{
            type:String | Number,
            default:'',
        }
    },
    data() {
        return {
            phoneUpload: false,//手机上传
            codeImg: ''
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    created() { },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 手机上传
         */
        handlePhoneUpload() {
            // 获取手机上传二维码
            getAppUploadQr({ orderId: this.orderId, uploadAccess:this.source}).then(res => {
                if (res.code = 200) {
                    this.phoneUpload = true
                    this.codeImg = res.data
                }
            })

        },
        /**
         * 本地上传
         */
        localUpload() {
            this.$emit('localUpload')
        },
        /**
         * 完成上传
         */
        uploadCompany(){
            this.$emit('uploadCompany')
        },
    },
}
</script>
<style lang="less" scoped>
.uploadDialog-warp {

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 20px;

    .btn {
        text-align: center;
        width: 198px;
        line-height: 42px;
        border: 1px solid #D2D2D2;
        margin-bottom: 18px;
        cursor: pointer;
    }

}

.code-warp {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;

    .code {
        width: 262px;
        height: 262px;
        margin-bottom: 20px;
    }


}
</style>